<template>
  <div>
    <el-card>
      <z-table :data="list" :columns="columns" :pagination="false" :maxHeight="750">
        <template #isDisplayHeader>
          {{ $t('enterprise::manager::是否显示') }}
          <el-tooltip :content="$t('enterprise::manager::showTips')" placement="top">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template #userName="{row}">
          <el-tag v-if="row.isAdmin" class="mr-8">{{ $t('enterprise::manager::我的') }}</el-tag>
          <span>{{ row.userName }}</span>
        </template>
        <template #isDisplay="{row}">
          <el-switch
            :value="row.isDisplay"
            :active-text="$t('enterprise::manager::开')"
            :inactive-text="$t('enterprise::manager::关')"
            :disabled="row.userId === merchantId"
            @change="changeStatus(row)"
          ></el-switch>
        </template>
        <template #operate="{row}">
          <el-button type="text" @click="editEnterprise(row)" v-if="row.isAdmin">
            {{ $t('enterprise::manager::编辑企业') }}
          </el-button>
          <el-button
            type="text"
            style="color: red"
            @click="deleteEnterprise(row)"
            :disabled="row.userId === merchantId"
            v-else
          >
            {{ $t('enterprise::manager::退出企业') }}
          </el-button>
        </template>
      </z-table>
    </el-card>
    <EditDialog v-model="visible" :editRow="editRow"></EditDialog>
  </div>
</template>

<script>
import EditDialog from './components/editDialog.vue'
import { updateIsDisplay, quitMerchant } from '@/server/user'
export default {
  components: { EditDialog },
  data() {
    return {
      visible: false,
      editRow: {},
      list: [],
      columns: [
        { prop: 'userName', label: this.$t('enterprise::manager::企业名称') },
        { prop: 'isDisplay', label: this.$t('enterprise::manager::是否显示'), slotHeaderName: 'isDisplayHeader' },
        { prop: 'operate', label: this.$t('enterprise::manager::操作'), width: 150 }
      ]
    }
  },
  methods: {
    editEnterprise(row) {
      this.editRow = row
      this.visible = true
    },
    deleteEnterprise(row) {
      this.$confirm(
        `<p>${this.$t('enterprise::manager::quit1')}</p><p><span style="color:red">${this.$t(
          'enterprise::manager::quit2'
        )}</span>,${this.$t('enterprise::manager::quit3')}</p>`,
        this.$t('enterprise::manager::提示'),
        {
          dangerouslyUseHTMLString: true,
          closeOnClickModal: false,
          type: 'warning'
        }
      ).then(async () => {
        const { data } = await quitMerchant(row.userId)
        if (data.code === this.$code) {
          this.$message.success(this.$t('enterprise::manager::退出成功'))
          this.$store.dispatch('getMerchant', true)
        }
      })
    },
    async changeStatus(row) {
      const { data } = await updateIsDisplay(row.userId, row.isDisplay ? 0 : 1)
      if (data.code === this.$code) {
        this.$message.success(this.$t('enterprise::manager::设置成功'))
        this.$store.dispatch('getMerchant', true)
      }
    }
  },
  computed: {
    merchantList() {
      return this.$store.state.user.merchantList
    },
    merchantId() {
      return this.$store.state.user.merchantId
    }
  },
  watch: {
    merchantList: {
      handler(val) {
        this.list = val
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped lang="scss"></style>
